module.exports = __webpack_public_path__ + "static/media/cardano-bg-element.69627324.png";